import Vue from 'vue'
import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export const palette = {
    mulberry: '#830051',
    mulberry80: '#9a3374',
    mulberry60: '#b36697',
    mulberry40: '#cc99b9',
    mulberry20: '#e6ccdc',
    green: '#c4d600',
    navy: '#003865',
    graphite: '#3f4444',
    blue: '#68d2df',
    magenta: '#d0006f',
    purple: '#3c1053',
    purple80: '#6F4386',
    purple60: '#A276B9',
    gold: '#f0ab00',
    platinum: '#9db0ac',
}

export const colors = {
    primary: palette.mulberry,
    accent: palette.green,

    loaderbg: '#fff',

    actions: palette.green,
    actionsText: '#000',

    error: palette.magenta,

    noDetect: palette.blue,
    insignificant: palette.green,
    low: palette.purple60,
    med: palette.purple80,
    high: palette.purple,

    mecLine: palette.graphite,
    pnecLine: palette.mulberry
}


export default new Vuetify({
    theme: {
        themes: {
            light: colors,
            dark: colors,
        },
    }
})

